(() => {
  const body = document.body;
  const header = document.querySelector('[data-site-header]');
  const nav = document.querySelector('[data-primary-nav]');
  const navToggle = document.querySelector('[data-nav-toggle]');
  const supportedLanguages = ['fr', 'en'];

  const setLanguage = (language, persist = true) => {
    const lang = supportedLanguages.includes(language) ? language : 'en';
    body.classList.remove('lang-fr', 'lang-en');
    body.classList.add(`lang-${lang}`);
    document.documentElement.lang = lang;
    document.documentElement.dir = 'ltr';
    document.querySelectorAll('[data-language]').forEach((button) => {
      const active = button.dataset.language === lang;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-program-select]').forEach((select) => {
      const active = select.dataset.programSelect === lang;
      select.disabled = !active;
      select.hidden = !active;
    });
    if (persist) {
      try { localStorage.setItem('aghili-language', lang); } catch (_) {}
    }
  };

  let savedLanguage = null;
  try { savedLanguage = localStorage.getItem('aghili-language'); } catch (_) {}
  const browserLanguage = (navigator.language || 'en').slice(0, 2).toLowerCase();
  setLanguage(savedLanguage || (supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en'), false);

  document.querySelectorAll('[data-language]').forEach((button) => {
    button.addEventListener('click', () => setLanguage(button.dataset.language));
  });

  const closeNav = () => {
    if (!nav || !navToggle) return;
    nav.classList.remove('is-open');
    navToggle.setAttribute('aria-expanded', 'false');
    body.classList.remove('nav-open');
  };

  navToggle?.addEventListener('click', () => {
    const open = navToggle.getAttribute('aria-expanded') !== 'true';
    navToggle.setAttribute('aria-expanded', String(open));
    nav?.classList.toggle('is-open', open);
    body.classList.toggle('nav-open', open);
  });
  nav?.addEventListener('click', (event) => {
    if (event.target.closest('a, [data-language]')) {
      window.requestAnimationFrame(closeNav);
    }
  });
  document.addEventListener('click', (event) => {
    if (
      navToggle?.getAttribute('aria-expanded') === 'true' &&
      !nav?.contains(event.target) &&
      !navToggle?.contains(event.target)
    ) {
      closeNav();
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeNav(); });
  ['hashchange', 'popstate', 'pagehide', 'orientationchange'].forEach((eventName) => {
    window.addEventListener(eventName, closeNav);
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth > 860) closeNav();
  });

  const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  document.querySelectorAll('[data-service-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const filter = button.dataset.serviceFilter;
      document.querySelectorAll('[data-service-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
      document.querySelectorAll('[data-category]').forEach((card) => {
        const categories = (card.dataset.category || '').split(' ');
        card.classList.toggle('is-filtered', filter !== 'all' && !categories.includes(filter));
      });
    });
  });

  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -35px' });
    reveals.forEach((element) => observer.observe(element));
  } else {
    reveals.forEach((element) => element.classList.add('is-visible'));
  }
})();
